angular.module('SupportAgent')
.config(function ($routeProvider) {
 $routeProvider
 .when('/', {
  /* TODO: This is a temporary solution, because first, the code here
   * doesn't belong here, which is a minor problem, the bigger problem
   * is … <resolved> … */
  resolveRedirectTo: function($q,L,INTERACT,INTRACTABLE) {
   if(!INTERACT.is_logged_in()) return '/login';
   return $q(function(resolve,reject) {
    INTRACTABLE.request('user/count',{},function(e,r) {
     if(e || (!r) || r._S!='ok') return L.error({err:e,r:r},"error fetching users count"),reject();
     resolve(r.count?'/support':'/user/create');
    });
   });
  },
  secure: true
 })
 .when('/support/:aid?/:cid?', {
  templateUrl: './snippets/pages/support.html',
  controller: 'SupportShowController',
  controllerAs: 'supportCtrl',
  reloadOnUrl: false,
  secure: true
 })
 .when('/dashboard', {
  templateUrl: './snippets/pages/dashboard.html',
  controller: 'DashboardController',
  controllerAs: 'dashboardCtrl',
  secure: true
 })
 .when('/login', {
  templateUrl: './snippets/pages/login.html',
  controller: 'LoginController',
  controllerAs: 'LoginCtrl'
 })
 .when('/register', {
  templateUrl: './snippets/pages/register.html',
  controller: 'RegisterController',
 })
 .when('/email-success', {
  templateUrl: './snippets/pages/email-success.html'
 })
 .when('/email-failure', {
  templateUrl: './snippets/pages/email-failure.html'
 })
 .when('/forgot-password', {
  templateUrl: './snippets/pages/forgot-password.html'
 })
 .when('/marketing', {
  templateUrl: './snippets/pages/marketing-engine.html',
  controller: 'MpacterController',
  controllerAs: 'mpacterCtrl',
 })
 .when('/analytics', {
  templateUrl: './snippets/pages/data-analytics.html',
  controller: 'DataAnalyticsController',
  controllerAs: 'analyticsCtrl',
 })
 .when('/user/search', {
  templateUrl: './snippets/pages/user-search.html',
  controller: 'UserSearchController',
  secure: true
 })
 .when('/user/create', {
  templateUrl: './snippets/pages/user-create.html',
  secure: true
 })
 .when('/administration', {
  templateUrl: './snippets/pages/administration.html',
  secure: true
 })
 .when('/kpi', {
  templateUrl: './snippets/pages/kpi.html',
  secure: true
 })
 .otherwise({
  redirectTo: '/'
 });
});
